<template>
  <div class="page-container">
    <div class="top-container">
      <img
        src="https://static5.yingsaidata.com/mip/img/3872510-yingsai-logo.png"
        class="img-logo"
        alt=""
      />
      <a-tooltip color="#ffffff" placement="bottomRight" overlayClassName="usercenter-tooltip">
        <template #title>
          <UserCenter></UserCenter>
        </template>
        <Avatar :src="baseInfo?.avatar" :name="baseInfo?.name" class="avatar" />
      </a-tooltip>
    </div>
    <div class="left-container">
      <div class="block">
        <div class="new-chat" @mouseenter="mouseEnter(chatItem)" @mouseleave="mouseLeave(chatItem)">
          <span @click="newChatClick">
            <img
              src="https://static5.yingsaidata.com/mip/img/9916204-new-chat-defult@2x.png"
              alt=""
            />
          </span>
        </div>
        <div class="icons-wrapper">
          <ul>
            <li
              :class="idx == activeIdx ? 'active' : ''"
              v-for="(item, idx) in tabList"
              :key="'key_' + idx"
              @click="navClick(item, idx)"
              @mouseenter="mouseEnter(item)"
              @mouseleave="mouseLeave(item)"
            >
              <template v-if="!item.diabled">
                <span class="tab-logo">
                  <img
                    class="logo"
                    :src="idx == activeIdx || item.isActive ? item.activeUrl : item.url"
                    alt=""
                  />
                </span>
                <p class="txt">{{ item.tabName }}</p>
              </template>
              <template v-else>
                <a-tooltip placement="top">
                  <template #title> <span style="font-size: 12px">即将上线</span> </template>
                  <span class="tab-logo">
                    <img class="logo" :src="idx == activeIdx ? item.activeUrl : item.url" alt="" />
                  </span>
                  <p class="txt">{{ item.tabName }}</p>
                </a-tooltip>
              </template>
            </li>
          </ul>
          <div class="line"></div>
        </div>

        <div class="history" @click="showHistory">
          <span>
            <img src="https://static5.yingsaidata.com/mip/img/5971220-1-history.png" alt="" />
          </span>
        </div>
      </div>
    </div>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
  <div class="session-group" v-show="isShowHistory">
    <SessionListGroup></SessionListGroup>
    <span class="tooltip-arrow">
      <span class="tooltip-arrow-content"></span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import useChatStore from '@/stores/chat'
import { storeToRefs } from 'pinia'
import Avatar from '@/components/avatar/index.vue'
import { useUserInfoStore } from '@/stores/user-info'
import UserCenter from '@/components/user-center/index.vue'
import { chatsMap } from '@/utils/constant'
import { stopSendIconClick } from '@/utils/chat'
import SessionListGroup from '../components/session-list/index.vue'

const router = useRouter()
const chatStores = useChatStore()
const userStore = useUserInfoStore()

const { isNewchat, isShowHistory, isShowLayoutHistory, sessionList, curSelectSession, isSending } =
  storeToRefs(chatStores)
const baseInfo = computed(() => userStore.userInfo)

const activeIdx = ref(0)
const activeName = ref('')
const chatItem = ref({
  default: 'https://static5.yingsaidata.com/mip/img/6081180-new-chat-active@2x.png',
  active: 'https://static5.yingsaidata.com/mip/img/6081180-new-chat-active@2x.png'
})

const tabList = ref([
  {
    tabName: '灵感广场',
    url: 'https://static5.yingsaidata.com/mip/img/7947945-square-default@2x.png',
    activeUrl: 'https://static5.yingsaidata.com/mip/img/6564781-square-active@3x.png',
    routeName: 'square',
    isActive: false
    // diabled: true
  },
  {
    tabName: '创作空间',
    url: 'https://static5.yingsaidata.com/mip/img/3244841-create-default@2x.png',
    activeUrl: 'https://static5.yingsaidata.com/mip/img/1164143-create-active@3x.png',
    routeName: 'chat',
    isActive: false
  },
  {
    tabName: '文生图',
    url: 'https://static5.yingsaidata.com/mip/img/4438938-wenshengtu@2x.png',
    activeUrl: 'https://static5.yingsaidata.com/mip/img/3707756-wenshengtu-active.png',
    routeName: 'articlePic',
    diabled: true
  },
  {
    tabName: '文生视频',
    url: 'https://static5.yingsaidata.com/mip/img/5772186-wenshengshipin@2x.png',
    activeUrl: 'https://static5.yingsaidata.com/mip/img/3926042-wenshengshipin-active.png',
    routeName: 'articleVedio',
    diabled: true
  },
  {
    tabName: '数字人',
    url: 'https://static5.yingsaidata.com/mip/img/2499965-shuziren@2x.png',
    activeUrl: 'https://static5.yingsaidata.com/mip/img/7724329-shuziren-active.png',
    routeName: 'digit',
    diabled: true
  }
])
console.log('router', router)
// 高亮当前路由
watch(
  () => router.currentRoute.value,
  (newValue: any) => {
    tabList.value.forEach((item, index) => {
      if (item.tabName == newValue.meta.name) {
        activeIdx.value = index
        activeName.value = item.routeName
      }
    })
  },
  { immediate: true }
)

const navClick = (item, index) => {
  if (item.diabled) {
    message.info('该功能暂未开放', 1.5)
    return
  }
  activeIdx.value = index
  // activeName.value = item.routeName
  if (isSending.value) {
    stopSendIconClick()
  }
  if (item.routeName == 'chat') {
    if (!curSelectSession.value.session_id) {
      chatStores.updateIsNewChat(true)
      chatStores.updateMapping({})
    }
    chatStores.updateCurUsedScene({})
  }

  router.push(`/${item.routeName}`)
}
const newChatClick = () => {
  if (isSending.value) {
    message.info(chatsMap.sendingTips)
    return
  }
  // if (chatStores.controller) {
  //   chatStores.controller.abort()
  // }
  router.push('/chat')
  chatStores.updateIsSending(false)
  chatStores.updateIsNewChat(true)
  chatStores.updateCurSelectSession({
    session_id: ''
  })
  let list = sessionList.value.map((item: any) => {
    item.isActive = false
    return item
  })
  chatStores.updateSessionList(list)
  chatStores.updateMapping({})
  chatStores.updateIsSending(false)
}
const showHistory = () => {
  chatStores.updateHistory(!chatStores.isShowHistory)
}
const mouseEnter = (item) => {
  item.isActive = true
}
const mouseLeave = (item) => {
  item.isActive = false
}
</script>

<style scoped lang="less">
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f8f9fc;
  .left-container {
    z-index: 16;
    left: 12px;
    position: fixed;
    top: 56px;
    bottom: 56px;
    width: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .new-chat {
      padding-left: 7px;
      border-top-right-radius: 65%;
      width: 60px;
      height: 60px;
      img {
        display: block;
        width: 28px;
        height: 28px;
      }
    }

    .new-chat,
    .history {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        display: block;
        width: 40px;
        height: 40px;
        padding: 6px;
        border-radius: 50%;
      }
      &:hover {
        span {
          background: #f3f5fa;
        }
      }
    }
    .history {
      border-bottom-right-radius: 65%;
      // padding-top: 22px;
      height: 80px;
      background: #ffffff;
      padding-left: 8px;
      img {
        display: block;
      }
      span {
        padding: 0;
      }
    }
    .icons-wrapper {
      margin-top: 8px;
      width: 60px;
      padding-top: 10px;
      ul {
        margin-bottom: 0;
      }
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 22px;
        cursor: pointer;
        > span {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
      .tab-logo {
        width: 48px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background: #f3f5fa;

        &.active {
          // background: #f3f5fa;
          border-radius: 50%;
        }
        .logo {
          display: block;
          width: 28px;
          height: 28px;
        }
      }
      .txt {
        color: rgba(0, 0, 0, 0.4);
        font-size: 12px;
        text-align: center;
        margin-top: 8px;
        margin-bottom: 0;
      }
      .line {
        width: 40px;
        margin-left: 10px;
        height: 1px;
        background: #f5f5f5;
      }
    }
    .new-chat,
    .icons-wrapper {
      background: #fcfcfc;
      box-sizing: border-box;
      border: 1px solid #ffffff;
      box-shadow: 0px 5.76px 14.4px 0px rgba(138, 138, 138, 0.1);
    }
  }
  .top-container {
    padding: 0 24px 0 24px;

    .img-logo {
      position: fixed;
      top: 24px;
      left: 24px;
      display: block;
      width: 98px;
      height: 26px;
    }
    .avatar {
      width: 32px;
      height: 32px;
      position: fixed;
      top: 24px;
      right: 24px;
    }
  }
}
.session-group {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 75px;
  z-index: 99;
  .tooltip-arrow {
    position: absolute;
    display: block;
    width: 13.07106781px;
    height: 13.07106781px;
    overflow: hidden;
    background: transparent;
    pointer-events: none;
    bottom: 11px;
    left: -1px;
    .tooltip-arrow-content {
      box-shadow: -6px 6px 14px #ffffff;
      transform: translate(6.53553391px) rotate(45deg);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      width: 10px;
      height: 10px;
      margin: auto;
      background-color: #ffffff;
      content: '';
      pointer-events: auto;
    }
  }
}
</style>
<style>
.usercenter-tooltip {
  min-width: 280px;
}
</style>
